<template>
	<div>
		<practice-request-cancelled />
		<practice-upcoming-bookings />
		<practice-booking-history />
	</div>
</template>

<script>
import PracticeRequestCancelled from '@/components/ui/dashboard/practice/cards/PracticeRequestCancelled';
import PracticeUpcomingBookings from '@/components/ui/dashboard/practice/dropdowns/PracticeUpcomingBookings';
import PracticeBookingHistory from '@/components/ui/dashboard/practice/dropdowns/PracticeBookingHistory';

export default {
	name: 'PracticeSuccessRequestCancelled',
	components: {
		PracticeRequestCancelled,
		PracticeUpcomingBookings,
		PracticeBookingHistory,
	},
	data: () => ({}),
};
</script>
